// useReadGoal — fires a one-shot analytics event when the user has scrolled
// past a given % of the document. Used on /kunskap/* to capture
// "kunskap_read_75" som Plausible/GA4 goal (Spår 7 #2).

import { useEffect, useRef } from "react";
import { track } from "@/lib/analytics";

export function useReadGoal(eventName: string, threshold = 0.75, props: Record<string, string | number> = {}) {
  const fired = useRef(false);
  useEffect(() => {
    if (typeof window === "undefined") return;
    fired.current = false;
    const onScroll = () => {
      if (fired.current) return;
      const doc = document.documentElement;
      const scrolled = window.scrollY + window.innerHeight;
      const total = doc.scrollHeight;
      if (total <= window.innerHeight) return;
      const ratio = scrolled / total;
      if (ratio >= threshold) {
        fired.current = true;
        track(eventName, { threshold, ...props });
      }
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [eventName, threshold, JSON.stringify(props)]);
}
